"use client";

import { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import api from "../../services/api";
import Swal from "sweetalert2";

const UserCreateModal = ({ show, onHide, onSuccess, editUser }) => {
  const isEdit = Boolean(editUser);

  const [form, setForm] = useState({
    code: "",
    name: "",
    family: "",
    codemelli: "",
    mobile: "",
    password: "",
    password2: "",
    role: "USER",
    category_id: "",
    storeId: "",
  });

  const [categories, setCategories] = useState([]);
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load categories & stores
  useEffect(() => {
    if (!show) return;

    const fetchData = async () => {
      try {
        const [catRes, storeRes] = await Promise.all([
          api.get("/admin/categories"),
          api.get("/admin/stores"),
        ]);
        setCategories(catRes.data);
        setStores(storeRes.data.items ?? storeRes.data);
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'خطا',
          text: 'خطا در دریافت داده‌ها',
        });
      }
    };
    fetchData();
  }, [show]);

  // Set form for edit
  useEffect(() => {
    if (editUser) {
      setForm({
        code: editUser.code || "",
        name: editUser.name || "",
        family: editUser.family || "",
        codemelli: editUser.codemelli || "",
        mobile: editUser.mobile || "",
        password: "",
        password2: "",
        role: editUser.role || "USER",
        category_id: editUser.category?.id || "",
        storeId: editUser.store?.id || "",
      });
    } else {
      setForm({
        code: "",
        name: "",
        family: "",
        codemelli: "",
        mobile: "",
        password: "",
        password2: "",
        role: "USER",
        category_id: "",
        storeId: "",
      });
    }
  }, [editUser]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.code || !form.name || !form.family || !form.mobile) {
      Swal.fire({
        icon: 'error',
        title: 'خطا',
        text: 'لطفاً فیلدهای ضروری را تکمیل کنید',
      });
      return;
    }

    if (!isEdit) {
      if (!form.password) {
        Swal.fire({
          icon: 'error',
          title: 'خطا',
          text: 'رمز عبور را وارد کنید',
        });
        return;
      }
    }

    if ((form.password || form.password2) && form.password !== form.password2) {
      Swal.fire({
        icon: 'error',
        title: 'خطا',
        text: 'رمز و تکرار آن یکسان نیستند',
      });
      return;
    }

    setLoading(true);
    try {
      const { password2, ...rest } = form;
      const payload = {
        ...rest,
        category_id: form.category_id ? Number(form.category_id) : null,
        storeId: form.storeId ? Number(form.storeId) : null,
      };

      if (isEdit) {
        await api.patch(`/admin/users/${editUser.id}`, payload);
      } else {
        await api.post("/admin/users", payload);
      }

      Swal.fire({
        icon: 'success',
        title: 'موفقیت',
        text: isEdit ? 'کاربر با موفقیت ویرایش شد' : 'کاربر جدید اضافه شد',
        timer: 2000,
        showConfirmButton: false
      });

      onSuccess?.();
      onHide();
    } catch (err) {
      console.error("❌ Error:", err.response?.data);
      Swal.fire({
        icon: 'error',
        title: 'خطا',
        text: err.response?.data?.message || "خطا در ذخیره اطلاعات",
        timer: 3000,
        showConfirmButton: false
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? "ویرایش کاربر" : "افزودن کاربر جدید"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="row g-3">
          <Form.Group className="col-md-6">
            <Form.Label>نام</Form.Label>
            <Form.Control
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="نام"
            />
          </Form.Group>
          <Form.Group className="col-md-6">
            <Form.Label>نام خانوادگی</Form.Label>
            <Form.Control
              name="family"
              value={form.family}
              onChange={handleChange}
              placeholder="نام خانوادگی"
            />
          </Form.Group>

          <Form.Group className="col-md-4">
            <Form.Label>کد کاربر</Form.Label>
            <Form.Control
              name="code"
              value={form.code}
              onChange={handleChange}
              placeholder="کد کاربر"
            />
          </Form.Group>

          <Form.Group className="col-md-4">
            <Form.Label>موبایل</Form.Label>
            <Form.Control
              name="mobile"
              value={form.mobile}
              onChange={handleChange}
              placeholder="شماره موبایل"
            />
          </Form.Group>

          <Form.Group className="col-md-4">
            <Form.Label>کد ملی</Form.Label>
            <Form.Control
              name="codemelli"
              value={form.codemelli}
              onChange={handleChange}
              placeholder="کد ملی"
            />
          </Form.Group>

          {/*!isEdit && (*/
            <>
              <Form.Group className="col-md-6">
                <Form.Label>رمز عبور (موقع ویرایش در صورت نیاز به تعویض پر شود)</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="رمز عبور"
                />
              </Form.Group>
              
              <Form.Group className="col-md-6">
                <Form.Label>تکرار رمز</Form.Label>
                <Form.Control
                  type="password"
                  name="password2"
                  value={form.password2}
                  onChange={handleChange}
                  placeholder="تکرار رمز"
                />
              </Form.Group>
            </>
          /*)*/}

          <Form.Group className="col-md-6">
            <Form.Label>نقش</Form.Label>
            <Form.Select name="role" value={form.role} onChange={handleChange}>
              <option value="USER">کاربر</option>
              <option value="STORE">فروشگاه</option>
              <option value="ADMIN">مدیر</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="col-md-6">
            <Form.Label>دسته</Form.Label>
            <Form.Select
              name="category_id"
              value={form.category_id}
              onChange={handleChange}
            >
              <option value="">انتخاب دسته</option>
              {categories.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="col-md-6">
            <Form.Label>فروشگاه</Form.Label>
            <Form.Select
              name="storeId"
              value={form.storeId}
              onChange={handleChange}
            >
              <option value="">انتخاب فروشگاه</option>
              {stores.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          انصراف
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? (
            <>
              <Spinner animation="border" size="sm" /> در حال ذخیره...
            </>
          ) : isEdit ? (
            "ذخیره تغییرات"
          ) : (
            "افزودن کاربر"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserCreateModal;
